export function createSilenceMonitor(thresholdLevel, silenceDurationMs) {
    let detectedAudio = false;
    let silenceStartedAt = null;
    let reported = false;
    return {
        sample(level, nowMs) {
            if (reported || detectedAudio)
                return false;
            if (level >= thresholdLevel) {
                detectedAudio = true;
                return false;
            }
            silenceStartedAt ??= nowMs;
            if (nowMs - silenceStartedAt >= silenceDurationMs) {
                reported = true;
                return true;
            }
            return false;
        },
        done() {
            return reported || detectedAudio;
        },
    };
}
//# sourceMappingURL=silenceMonitor.js.map